import { observer } from "mobx-react-lite";
import { Popup } from "react-map-gl/mapbox";
import type { OverlaysStore } from "@/components/Map/Overlays/OverlaysStore";

interface OverlayHoverPopupProps {
	overlaysStore: OverlaysStore;
}

/**
 * Small "tag" tooltip that follows the cursor while hovering an overlay
 * feature, showing the overlay name. State is driven by OverlaysStore.hover,
 * which is set by mapbox mousemove/mouseleave handlers wired in ensureLayers.
 */
export const OverlayHoverPopup = observer(({ overlaysStore }: OverlayHoverPopupProps) => {
	const hover = overlaysStore.hover;
	if (!hover) return null;

	return (
		<Popup
			className="popup-overlay-tag"
			longitude={hover.lng}
			latitude={hover.lat}
			closeButton={false}
			closeOnClick={false}
			closeOnMove={false}
			anchor="bottom"
			offset={12}
		>
			<div
				className="px-2 py-1 text-xs font-medium text-white rounded shadow-md whitespace-nowrap pointer-events-none"
				style={{ backgroundColor: hover.color }}
			>
				{hover.name}
			</div>
		</Popup>
	);
});
